const stylesTemplates = {
  username: {
    tag: 'div',
    styles: 'color:#0F0F0F;font-size:16px;line-height:26px;font-weight: bold;text-transform: capitalize;' +
      'font-family:Helvetica,Arial,sans-serif;'
  },
  position: {
    tag: 'div',
    styles: 'color:#A6A6A6;font-size:14px;line-height:26px;padding: 0 0 9px 0;font-family:Helvetica,Arial,sans-serif;'
  },
  phone: 'color:#0F0F0F;font-size:16px;line-height:20px;padding:0 18px 0 7px;text-decoration:none;',
  companyPhone: 'color:#0F0F0F;font-size:16px;line-height:20px;padding:0 18px 0 7px;text-decoration:none;',
  companyAddress: {
    tag: 'span',
    styles: 'color:#0F0F0F;font-size:16px;line-height:26px;padding:0 18px 0 11px;letter-spacing:-0.4px;'
  },
  socialsIcons: {
    tag: 'div',
    styles: 'padding: 25px 0 0 0;'
  },
  information: {
    tag: 'p',
    styles: 'padding: 5px 0 0 0;color:#A9A9A9;font-size:12px;line-height: 135.4%;margin:12px 0 0 0;'
  },
  awards: {
    tag: 'div',
    styles: 'padding: 19px 0 0 0;'
  },
  block: {
    tag: 'div',
    styles: 'margin: 5px 0 0 0;'
  },
  additional: {
    tag: 'div',
    styles: 'margin: 5px 0 0 0;'
  },
  emailStyle: 'color:#0F0F0F;font-size:16px;line-height:20px;padding:0 18px 0 7px;text-decoration:none;',
  companySiteStyle: 'color:#0F0F0F;font-size:16px;line-height:20px;padding:0 18px 0 7px;text-decoration:none'
}

export default stylesTemplates



// WEBPACK FOOTER //
// ./src/constants/signatureGmail/stylesTemplatesType2.js